import styled from "styled-components";
import TelegramPairSelector from "./client/connections/TelegramPairSelector";

export const StyledTelegramBotWrapper = styled.div`
  .tab-body {
    @media screen and (max-width: 992px) {
      padding: 0;
      border: none;
      border-radius: 0;
      box-shadow: none;
    }
  }

  .content-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px;
    grid-template-rows: 45px;
    grid-gap: 20px;

    button {
      height: 100%;
    }

    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;

      button {
        width: max-content;
        height: 45px;
      }
    }
  }

  .bot-list {
    &__head, &__row {
      grid-template-columns: 150px minmax(250px, 1.5fr) 240px;
    }

    &__actions {
      display: grid;
      grid-template-columns: repeat(2, max-content);
      grid-gap: 25px;
    }
  }

  .chat-list {
    &__head, &__row {
      grid-template-columns: 100px  100px repeat(4, 1fr);
    }
  }

  .invoices {
    &__head, &__row {
      grid-template-columns: minmax(150px, 1fr) repeat(12, minmax(0, 1fr))
    }
  }

  .manager-list {
    &__head, &__row {
      grid-template-columns: 100px repeat(7, minmax(100px, 1fr)) 150px;
    }

    &__actions {
      display: grid;
      grid-template-columns: 100%;
      grid-gap: 12px;
    }
  }


  .tg-tab-actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px;
  }

  .tg-bots-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 8px;

    &__field {
      width: 100%;
    }

    &__token-row {
      display: grid;
      grid-template-columns: 1fr 44px;
      align-items: center;
      gap: 8px;
    }
  }
`;


export const StyledTelegramPairSelector = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid ${({theme}) => theme.surface.border};
  border-radius: 4px;
  padding: 4px 0;
  margin-top: 4px;

  .tg-pair-selector__row {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-right: 12px;
    border-radius: 4px;

    &:hover {
      background-color: ${({theme}) => theme.brand.soft};
    }
  }

  .tg-pair-selector__label {
    font-size: 14px;
    color: ${({theme}) => theme.text.primary};
    user-select: none;
  }
`;